<template lang="pug">
.v-params.params(v-if="block")
	.params__wrapper(:class="block.className || ''")
		template(v-if="isSm")
			.params__title-container
				.params__title-wrapper
					v-svg-icon.params__title-icon.js-close-modal(icon="back-arrow")
					.params__title-main(v-if="block.title") {{block.title}}
				a.params__btn(v-if="block.btn"
						:href="block.btn.link"
						target="_blank"
						rel="nofollow"
						:class="block.btn.className || ''")
					| {{block.btn.text}}
					v-svg-icon.params__btn-icon(v-if="block.btn.btnIcon" :icon="block.btn.btnIcon")
		template(v-else)
			.params__title(v-if="block.title && block.type === 'full'") {{block.title}}
			a.params__btn(v-if="block.btn"
					:href="block.btn.link"
					target="_blank"
					rel="nofollow"
					:class="block.btn.className || ''")
				| {{block.btn.text}}
				v-svg-icon.params__btn-icon(v-if="block.btn.btnIcon"
						:class="block.btn.iconClass || ''"
						:icon="block.btn.btnIcon")
		template(v-if="block.type === 'full'"
				v-for="(param, paramIndex) in this.block.params"
				:key="paramIndex")
			.key-value-list.flc
				.key-value-list__title-group(v-if="param.groupName") {{param.groupName}}
				.key-value-list__item(v-if="param.items && param.items.length"
						v-for="(item, itemIndex) in param.items"
						:key="itemIndex")
					.key-value-list__start-wrapper
						.key-value-list__item-start(v-html="item.name")
					.key-value-list__end-wrapper
						.key-value-list__item-end(v-html="Array.isArray(item.value) ? item.value.join(' / ') : item.value")
						.key-value-list__tooltip-wrapper(v-if="item.description")
							template(v-if="isSm")
								v-svg-icon.key-value-list__tooltip-icon(icon="tooltip-icon"
										@click="openTooltip(item.description)")
							template(v-else)
								v-svg-icon.key-value-list__tooltip-icon(icon="tooltip-icon")
								.key-value-list__tooltip-container.key-value-list__tooltip-container--modal
									.key-value-list__tooltip
										.key-value-list__tooltip-text.scrollbar(v-if="item.description" v-html="item.description" )
		template(v-if="block.type === 'short'")
			.key-value-list.flc
				.key-value-list__item(v-for="(param, paramIndex) in displayedParams"
						:key="paramIndex")
					.key-value-list__start-wrapper
						.key-value-list__item-start(v-html="param.name")
					.key-value-list__end-wrapper
						.key-value-list__item-end(v-html="Array.isArray(param.value) ? param.value.join(' / ') : param.value")
						.key-value-list__tooltip-wrapper(v-if="param.description")
							template(v-if="isSm")
								v-svg-icon.key-value-list__tooltip-icon(icon="tooltip-icon"
										@click="openTooltip(param.description)")
							template(v-else)
								v-svg-icon.key-value-list__tooltip-icon(icon="tooltip-icon")
								.key-value-list__tooltip-container
									.key-value-list__tooltip
										.key-value-list__tooltip-text.scrollbar(v-if="param.description" v-html="param.description" )
			.key-value-list__text-btn(v-if="block.allParams" @click="openParams") Все характеристики
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller.js';

export default {
	props: {
		dataSource: {
			type: [Object, String],
			default: null
		}
	},

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			block: null,
			isHovered: {},
			title: 'Характеристики',
			showAll: false,
			descriptionCount: 10,
		};
	},

	computed: {
		displayedParams() {
			if(this.block.params)
				return this.showAll ? this.block.params : this.block.params.slice(0, this.descriptionCount);
		}
	},

	methods: {
		openTooltip(text) {
			controller.openModal({
				className: 'modal--mid',
				content: `<v-modal-window>${text}</v-modal-window>`
			});
		},

		openParams() {
			controller.openModal({
				className: 'modal--lg',
				component: {
					name: 'v-params',
					props: {
						dataSource: this.block.allParams,
					}
				}
			});
		},

		dataSet(data) {
			this.block = data;
		}
	}
};
</script>